/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { Status, Wrapper } from "@googlemaps/react-wrapper";
import { usePath } from "../../contexts/path/path";
import {
  GET_CITY_BOUNDS,
  GET_DIRECTIONS_BOUNDS,
  GET_DISTRICT_BOUNDS,
} from "../../graphql/queries/districtBoundsInfo";
import logger from "../../../console";
import css from "../../pages/map/.module.scss";
import Config from "../../common/config";
import { Icon } from "@/components/icon";

export const restriction = {
  latLngBounds: {
    south: 16.3478913436,
    north: 34.6323360532,
    east: 55.6666593769,
    west: 32.161008816,
  },
  strictBounds: true,
};
export function createHtmlListingMarker({ text, className }) {
  const markerDivElement = document.createElement("div");
  markerDivElement.className = className;
  markerDivElement.innerHTML = text;
  return markerDivElement;
}
export function createHtmlImageMarker({ src, className }) {
  const imageElement = document.createElement("img");
  imageElement.className = className;
  imageElement.src = src;
  imageElement.style.background = "rgba(174,174,174,0.38)";
  imageElement.onload = () => {
    imageElement.style.background = null;
  };
  return imageElement;
}
export function DrawingButton({
  map,
  drawingClassName,
  setIsDrawing,
  isDrawing,
  onPolygonDrawn,
}) {
  const { updateContext } = usePath();
  const drawing = useRef({
    polygon: null,
    polyline: null,
    started: false,
    finished: false,
    paths: [],
  });
  const onStartDrawing = () => {
    if (drawing.current.finished) return;
    drawing.current.started = true;
    drawing.current.finished = false;
    map.setOptions({
      draggable: false,
      scrollwheel: false,
      disableDoubleClickZoom: true,
    });
  };

  const onDrawing = (evt) => {
    if (drawing.current.started) {
      drawing.current.paths = [...(drawing.current.paths || []), evt.latLng];
      drawing.current.polyline.setPath(drawing.current.paths);
    }
  };

  useEffect(() => {
    if (isDrawing)
      return () => {
        drawing.current?.polyline?.setPath([]);
        drawing.current?.polygon?.setPaths([]);
      };
  }, [isDrawing]);
  const onFinishDrawing = () => {
    if (drawing.current.started) {
      drawing.current.polygon = new google.maps.Polygon({
        strokeColor: "#52b54a",
        strokeWeight: 2,
        path: drawing.current.paths,
        fillColor: "#00000000",
        fillOpacity: 0.35,
        clickable: false,
        map: map,
      });
      drawing.current.polyline.setMap(null);
      drawing.current.polyline.setPath([]);
      drawing.current.started = false;
      drawing.current.finished = true;
      map.setOptions({
        draggable: true,
        scrollwheel: true,
        disableDoubleClickZoom: false,
      });
      const polygonData = drawing.current.paths.map((a) => a.toJSON());
      updateContext({
        polygon: polygonData,
      });
      // Notify parent that a polygon was drawn by the user and pass the polygon data
      if (onPolygonDrawn) {
        onPolygonDrawn(true, polygonData);
      }
    }
  };

  function firefoxAndSafariListener() {
    function listener(e) {
      e.preventDefault();
    }

    window.addEventListener("mousemove", listener, {
      passive: false,
    });
    return {
      remove: () =>
        window.removeEventListener("mousemove", listener, {
          passive: false,
        }),
    };
  }
  useEffect(() => {
    if (!map) return;

    drawing.current.polyline = new google.maps.Polyline({
      strokeColor: "#52b54a",
      strokeWeight: 2,
      fillOpacity: 0.35,
      clickable: false,
    });
    drawing.current.polyline.setMap(map);
    const listeners = [];

    if (isDrawing)
      listeners.push(
        map.addListener("mousedown", onStartDrawing),
        map.addListener("mousemove", onDrawing),
        map.addListener("mouseup", onFinishDrawing),
        map.addListener("touchmove", onStartDrawing),
        map.addListener("touchstart", onStartDrawing),
        map.addListener("touchend", onFinishDrawing),
        firefoxAndSafariListener(),
      );
    return () => {
      for (const listener of listeners) {
        listener.remove();
      }
    };
  }, [map, isDrawing, updateContext]);
  return (
    <button
      className={(isDrawing && drawingClassName) || ""}
      onClick={() => {
        const isdrwing = !isDrawing;
        if (!isdrwing) {
          drawing.current?.polyline?.setPath([]);
          drawing.current?.polygon?.setPaths([]);
          drawing.current.paths = [];
          updateContext({ polygon: undefined });
          // Notify parent that polygon was removed
          if (onPolygonDrawn) {
            onPolygonDrawn(false, null);
          }
        } else {
          drawing.current.finished = false;
        }
        setIsDrawing(isdrwing);
        map.setOptions({
          draggable: !isdrwing,
          scrollwheel: !isdrwing,
          disableDoubleClickZoom: isdrwing,
        });
      }}
    >
      <Icon name={!isDrawing ? "draw" : "drawWhite"} height={20} width={20} />
      حدد الرسم
    </button>
  );
}

export function createHtmlCityMarker({ text, className }) {
  const markerDivElement = document.createElement("div");
  markerDivElement.className = className;
  markerDivElement.textContent = text;
  return markerDivElement;
}
export function useBounds() {
  const path = usePath();
  const [bounds, setBounds] = useState();
  const [getDistrictBounds] = useLazyQuery(GET_DISTRICT_BOUNDS);
  const [getCityBounds] = useLazyQuery(GET_CITY_BOUNDS);
  const [getDirectionBounds] = useLazyQuery(GET_DIRECTIONS_BOUNDS);

  useEffect(() => {
    if (path.district) {
      getDistrictBounds({
        variables: {
          district_id: path.district.id || path.district.district_id,
        },
      })
        .then(({ data }) => {
          const _bounds = data?.Web?.districtBoundsInfo?.bounds;
          if (_bounds) return setBounds(_bounds);
        })
        .catch(logger.log);

      return;
    }

    if (path.direction) {
      getDirectionBounds({
        variables: {
          id: path.direction.id || path.direction.direction_id,
        },
      })
        .then(({ data }) => {
          const _bounds = data?.Web?.directionBoundsInfo?.bounds;
          if (_bounds) return setBounds(_bounds);
        })
        .catch(logger.log);
      return;
    }

    if (path.city) {
      getCityBounds({
        variables: {
          id: path.city.id || path.city.city_id,
        },
      })
        .then(({ data }) => {
          const _bounds = data?.Web?.cityBoundsInfo?.bounds;
          if (_bounds) return setBounds(_bounds);
        })
        .catch(logger.log);
      return;
    }
  }, [path.district, path.direction, path.city]);
  return bounds;
}

export function MapDecorator({ center, zoom, onLoad } = {}) {
  const mapContainer = useRef();
  const map = useRef(null);
  useEffect(() => {
    map.current = new google.maps.Map(mapContainer.current, {
      center,
      zoom,
      mapId: "c15190175679eea6",
      gestureHandling: "greedy",
      disableDefaultUI: true,
      restriction,
    });
    onLoad(map.current);
    window.map = map.current;
  }, []);

  return <div ref={mapContainer} id="map" className={css.map} />;
}

export function Map(props) {
  useEffect(() => {
    document.body.classList.add(css.hideOverflow);
    document.documentElement.classList.add(css.hideOverflow);
    return () => {
      document.body.classList.remove(css.hideOverflow);
      document.documentElement.classList.remove(css.hideOverflow);
    };
  }, []);
  return (
    <Wrapper
      libraries={["marker", "drawing"]}
      apiKey={Config.GM_API_KEY}
      render={render}
    >
      <MapDecorator {...props} />
    </Wrapper>
  );
}

export const render = (status) => {
  if (status === Status.LOADING) {
    return <div className={css.mapHolder} />;
  }
  return <div>Error</div>;
};
